import {http} from '@/utils';
import {
  isFissionV4DisabledError,
  useFissionV4AvailabilityStore,
} from './fission-v4-availability.store';

const FISSION_V4_API_PREFIX = 'app/fission/v4';

export type FissionV4ProgressStatus =
  | 'WAIT_OPEN'
  | 'IN_PROGRESS'
  | 'FINISHED'
  | 'EXPIRED'
  | string;

export interface FissionV4Progress {
  status?: FissionV4ProgressStatus;
  roundId?: number;
  currentAmount?: number;
  remainingCount?: number;
  stageNo?: number;
  stageName?: string;
  expireTime?: string;
  expireSeconds?: number;
  dailyResetSeconds?: number;
  frontAwardItems?: number[];
  boxNumArr?: number[];
  rewardRecordId?: number;
  rewardAmount?: number;
  rewardStatus?: string;
  withdrawable?: boolean;
  targetAmount?: number;
}

export interface FissionV4Open {
  roundId?: number;
  openAmount?: number;
  targetAmount?: number;
  currentAmount?: number;
  remainingCount?: number;
  stageNo?: number;
  stageName?: string;
  expireTime?: string;
  frontAwardItems?: number[];
  boxNumArr?: number[];
}

export interface FissionV4Spin {
  frontDisplayValue?: number;
  rewardAmount?: number;
  currentAmount?: number;
  remainingCount?: number;
  stageNo?: number;
  stageName?: string;
  completed?: boolean;
  issuedAmount?: number;
  expireTime?: string;
}

export interface FissionV4ProgressRecord {
  id?: number;
  roundId?: number;
  eventType?: string;
  rewardAmount?: number;
  afterAmount?: number;
  remainingCount?: number;
  contributionScore?: number;
  frontDisplayValue?: number;
  createTime?: string | number;
}

export interface FissionV4RewardRecord {
  id?: number;
  roundId?: number;
  rewardAmount?: number;
  status?: string;
  issueTime?: string;
  createTime?: string;
}

export interface FissionV4Withdraw {
  rewardRecordId?: number;
  roundId?: number;
  rewardAmount?: number;
  status?: string;
  issueTime?: string;
}

export interface FissionV4Broadcast {
  userId?: number;
  nickName?: string;
  rewardAmount?: number;
  issueTime?: string;
}

export interface FissionV4ProgressRecordsParams {
  roundId?: number;
  pageSize?: number;
}

export async function getFissionV4Progress() {
  try {
    const progress = await http.post<null, FissionV4Progress>(
      `${FISSION_V4_API_PREFIX}/progress`,
    );
    useFissionV4AvailabilityStore.getState().setWheelEnabled(true);
    return progress;
  } catch (error) {
    if (isFissionV4DisabledError(error)) {
      useFissionV4AvailabilityStore.getState().setWheelEnabled(false);
    }
    throw error;
  }
}

export function openFissionV4Round() {
  return http.post<null, FissionV4Open>(`${FISSION_V4_API_PREFIX}/open`);
}

export function spinFissionV4Wheel() {
  return http.post<null, FissionV4Spin>(`${FISSION_V4_API_PREFIX}/spin`);
}

export function withdrawFissionV4Reward() {
  return http.post<null, FissionV4Withdraw>(
    `${FISSION_V4_API_PREFIX}/withdraw`,
  );
}

export function getFissionV4ProgressRecords(
  params: FissionV4ProgressRecordsParams = {},
) {
  return http.post<null, FissionV4ProgressRecord[]>(
    `${FISSION_V4_API_PREFIX}/progress-records`,
    null,
    {params},
  );
}

export function getFissionV4RewardRecords() {
  return http.post<null, FissionV4RewardRecord[]>(
    `${FISSION_V4_API_PREFIX}/reward-records`,
  );
}

export function getFissionV4Broadcast() {
  return http.post<null, FissionV4Broadcast[]>(
    `${FISSION_V4_API_PREFIX}/broadcast`,
  );
}
